"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    EN: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday',
    ],
    AR: ['الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'جمعة', 'السبت', 'الأحد'],
};
